<template>
  <div class="trail-campsite flex items-center gap-3 px-4 py-2 rounded-xl bg-amber-50 border border-amber-200 shadow-sm">
    <!-- Tent icon (inline SVG) -->
    <svg width="28" height="28" viewBox="0 0 28 28" fill="none" class="shrink-0">
      <!-- Tent body -->
      <polygon points="14,4 4,24 24,24" fill="#d97706" opacity="0.8" />
      <polygon points="14,4 9,24 14,16 19,24" fill="#f59e0b" />
      <!-- Tent opening -->
      <polygon points="12,24 14,16 16,24" fill="#92400e" />
      <!-- Flag pole -->
      <line x1="14" y1="2" x2="14" y2="6" stroke="#92400e" stroke-width="1.5" />
      <!-- Flag -->
      <polygon points="14,2 20,4 14,6" fill="#ef4444" />
    </svg>

    <!-- Unit title -->
    <div>
      <div class="text-xs text-amber-600 font-semibold uppercase tracking-wide">Checkpoint</div>
      <div class="text-sm font-bold text-amber-900">{{ title }}</div>
    </div>
  </div>
</template>

<script setup>
defineProps({
  title: { type: String, required: true }
});
</script>
